"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _Raven = _interopRequireDefault(require("Raven"));

var _HomeDAO = _interopRequireDefault(require("../data/HomeDAO"));

var _Loading = _interopRequireDefault(require("../templates/Loading"));

var _redirect = _interopRequireDefault(require("../utils/redirect"));

var _urls = require("../utils/urls");

var RootEntry = /*#__PURE__*/function () {
  function RootEntry() {
    (0, _classCallCheck2.default)(this, RootEntry);
  }

  (0, _createClass2.default)(RootEntry, [{
    key: "start",
    value: function start() {
      _PortalIdParser.default.getPortalIdFromQueryParam();

      this.page = document.getElementsByClassName('page')[0];
      this.renderLoading();

      _HomeDAO.default.get().done(function (_ref) {
        var uri = _ref.uri;
        return (0, _redirect.default)(uri);
      }).fail(this.homeFailure.bind(this));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      this.page.appendChild((0, _Loading.default)());
    }
  }, {
    key: "homeFailure",
    value: function homeFailure(errorResp) {
      if (errorResp.status === 400 || errorResp.status === 401 || errorResp.status === 403) {
        (0, _redirect.default)((0, _urls.login)(_PortalIdParser.default.getPortalIdFromQueryParam()));
      } else {
        _Raven.default.captureMessage('Home api error', {
          extra: {
            readyState: errorResp.readyState,
            responseText: errorResp.responseText,
            responseURL: errorResp.responseURL,
            status: errorResp.status,
            statusText: errorResp.statusText
          }
        });

        (0, _redirect.default)((0, _urls.error)());
      }
    }
  }]);
  return RootEntry;
}();

new RootEntry().start();